import { Student } from '../../../shared-components/student/student.model';

export class FreeReducedMealAppFamily {
    FamilyID: number;
    ParentType: string;
    Students: Student[];
    UserCanSeeAllStudents: boolean;

    Selected: boolean;
}